import React, { useState, useRef, useEffect } from 'react';
import { Copy, Check, RefreshCw } from 'lucide-react';

// Custom X (Twitter) icon component with more accurate X logo
const XIcon = () => (
  <svg 
    width="16" 
    height="16" 
    viewBox="0 0 24 24" 
    fill="currentColor" 
    stroke="none"
  >
    <path d="M13.3174 10.7749L19.1457 4H17.7646L12.7039 9.88256L8.66193 4H4L10.1242 12.8955L4 20H5.38111L10.7379 13.7878L15.0217 20H19.6837L13.3174 10.7749ZM11.4389 12.9737L10.7837 12.0409L5.90569 5.03728H7.87994L11.7786 10.566L12.4338 11.4988L17.5661 18.9498H15.5918L11.4389 12.9737Z" />
  </svg>
);

// test

const TradingInterface = () => {

  const useLocalBackend = true; 
  // State to track the number of charts to display
  const [chartCount, setChartCount] = useState(4);

  // State to track which addresses have been copied
  const [copiedAddresses, setCopiedAddresses] = useState({});

  // State to track active tab (New Pairs or Popular)
  const [activeTab, setActiveTab] = useState('popular');

  // State to track which charts have been replaced
  const [replacedCharts, setReplacedCharts] = useState({});

  // State for dropdown search on individual charts
  const [activeChart, setActiveChart] = useState(null);
  const [chartSearchQuery, setChartSearchQuery] = useState('');
  const chartSearchRef = useRef(null);
  const chartDropdownRef = useRef(null);

  // New state for recent tokens from scraper
  const [recentTokens, setRecentTokens] = useState([]);
  const [isLoadingTokens, setIsLoadingTokens] = useState(false);
  const [tokenError, setTokenError] = useState(null);

  // State to track the last time tokens were fetched
  const [lastFetchTime, setLastFetchTime] = useState(0);

  const API_BASE_URL = 'https://7b2d-75-117-185-34.ngrok-free.app/api'


  console.log("API URL:", API_BASE_URL + "/tokens/recent");

const popularTokens = [
    {
      ticker: "LAUNCHCOIN",
      tokenAddress: "Ey59PH7Z4BFU4HjyKnyMdWt5GGN76KazTAwQihoUXRnk",
      twitterUrl: "https://x.com/launchcoin",
      chain: "sol",
      name: "Launch Coin on Believe",
      exchange: "GMGN",
      logoUrl: "https://wsrv.nl/?w=32&h=32&url=https%3A%2F%2Fipfs.io%2Fipfs%2Fbafkreibeqt7fvgn2ubl4tha6sljnici2eus42dauxgtrdvfjf6m3vkdkoi&dpr=2"
    },
    {
      ticker: "STARTUP",
      tokenAddress: "97PVGU2DzFqsAWaYU17ZBqGvQFmkqtdMywYBNPAfy8vy",
      twitterUrl: "https://x.com/startuponsol",
      chain: "sol",
      name: "Startup",
      exchange: "GMGN",
      logoUrl: "https://pbs.twimg.com/profile_images/1922316572959330304/FY-YVs65_400x400.jpg"
    },
    {
      ticker: "GOONC",
      tokenAddress: "ENfpbQUM5xAnNP8ecyEQGFJ6KwbuPjMwv7ZjR29cDuAb",
      twitterUrl: "",
      chain: "sol",
      name: "gooncoin",
      exchange: "GMGN",
      logoUrl: "https://wsrv.nl/?w=32&h=32&url=https%3A%2F%2Fipfs.io%2Fipfs%2Fbafkreiebjj52eznuxsmc6djnxz3n6dbuhyt44xv42xqlk3kbaoudog64ji&dpr=2"
    },
    {
      ticker: "DUPE",
      tokenAddress: "fRfKGCriduzDwSudCwpL7ySCEiboNuryhZDVJtr1a1C",
      twitterUrl: "https://x.com/dupedotcom",
      chain: "sol",
      name: "Dupe",
      exchange: "GMGN",
      logoUrl: "https://pbs.twimg.com/profile_images/1772006083520786433/B3ihEh1g_400x400.jpg"
    },
    {
      ticker: "BUDDY",
      tokenAddress: "65svCEvM4HdBHXKDxfhjm3yw1A6mKXkdS6HXWXDQTSNA",
      twitterUrl: "https://x.com/AlexFinnX/status/1917732321916248165",
      chain: "sol",
      name: "CreatorBuddy",
      exchange: "GMGN",
      logoUrl: "https://pbs.twimg.com/profile_images/1907567991086264320/If3gEl6f_400x400.png"
    },
    {
      ticker: "UBER",
      tokenAddress: "8V6pDEmXV3iKC3nVjDUeDqMPBrTq8y69EovCxTokyyFd",
      twitterUrl: "https://x.com/uberdotfun",
      chain: "sol",
      name: "Uberdotfun",
      exchange: "GMGN",
      logoUrl: "https://wsrv.nl/?w=32&h=32&url=https%3A%2F%2Fipfs.io%2Fipfs%2Fbafkreicfwrjxsh4gdhpntdx7mnb7zvzcy2oltv3ixgmfhy3kpzn3ozdoqm&dpr=2"
    },
    {
      ticker: "FITCOIN",
      tokenAddress: "Cr2mM4szbt8286XMn7iTpY5A8S17LbGAu1UyodkyEwn4",
      twitterUrl: "https://x.com/fittedcloset",
      chain: "sol",
      name: "FITCOIN",
      exchange: "GMGN",
      logoUrl: "https://pbs.twimg.com/profile_images/1908842339105173504/WQ9AQAsX_400x400.jpg"
    },
    {
      ticker: "GIGGLES",
      tokenAddress: "Bsow2wFkVzy1itJnhLke6VRTqoEkYQZp7kbwPtS87FyN",
      twitterUrl: "https://x.com/usegiggles",
      chain: "sol",
      name: "Giggles",
      exchange: "GMGN",
      logoUrl: "https://wsrv.nl/?w=32&h=32&url=https%3A%2F%2Fipfs.io%2Fipfs%2Fbafkreiereq2pt62rs3toqemgbb22at2mc64v2ye6xvpbibpti3624bu44u&dpr=2"

    },
    {
      ticker: "YAPPER",
      tokenAddress: "H1aoUqmp2vJu5o8w3o8LjrN6jKyWErS69PtYxGhfoXxf",
      twitterUrl: "https://x.com/ehalm_/status/1922780376235229197",
      chain: "sol",
      name: "Yapper",
      exchange: "GMGN",
      logoUrl: "https://wsrv.nl/?w=32&h=32&url=https%3A%2F%2Fipfs.io%2Fipfs%2Fbafybeigjzfyhbclxsugxgrufxn6gz7otrxojkrm26caqosduslv55bix7m&dpr=2"
    },
    {
      ticker: "THERANOS",
      tokenAddress: "GNxYv32buvqPS7M2GuXHxSxSN8weEkQiRuD575LXRYvu",
      twitterUrl: "https://x.com/TheranosOnSol",
      chain: "sol",
      name: "Theranos",
      exchange: "GMGN",
      logoUrl: "https://pbs.twimg.com/profile_images/1923575194943102976/EZnZ87Q4_400x400.jpg"
    },
    {
      ticker: "UNICORN",
      tokenAddress: "DzN1qkcRdsxQRFb9yVvz73Fnu6SbD3f5oJgArVdx7Nzc",
      twitterUrl: "https://x.com/Unicorn1b",
      chain: "sol",
      name: "Unicorn",
      exchange: "GMGN",
      logoUrl: "https://pbs.twimg.com/profile_images/1922390179979132928/KUua-BYC_400x400.jpg"
    },
    {
      ticker: "PCULE",
      tokenAddress: "J27UYHX5oeaG1YbUGQc8BmJySXDjNWChdGB2Pi2TMDAq",
      twitterUrl: "https://x.com/polycule_bot",
      chain: "sol",
      name: "Polycule",
      exchange: "GMGN",
      logoUrl: "https://pbs.twimg.com/profile_images/1887215655415689216/oCpgZjUF_400x400.jpg"
    },
    {
      ticker: "BUMP",
      tokenAddress: "5fG1KadrP3yD66gx4GgkFpvLE2UvzxwGKJLWsd1cyoNv",
      twitterUrl: "https://x.com/MilesFeldstein",
      chain: "sol",
      name: "Bump Apps",
      exchange: "GMGN",
      logoUrl: "https://wsrv.nl/?w=32&h=32&url=https%3A%2F%2Fipfs.io%2Fipfs%2Fbafkreicl6v3flcuwsofh7gihkz2evuwn5mvj7hvgomzbo33i4ge4zfroii&dpr=2"
    },
    {
      ticker: "NOODLE",
      tokenAddress: "7cEgQdp8JTXvBrpjSzji7bLEeCHWENRwX62B2Ep97k5H",
      twitterUrl: "https://x.com/play_noodle",
      chain: "sol",
      name: "Noodle",
      exchange: "GMGN",
      logoUrl: "https://pbs.twimg.com/profile_images/1921253692642107392/y1UivnNJ_400x400.jpg"
    },
    {
      ticker: "CLOON",
      tokenAddress: "Hnks94gfX3TfvZSNM1ZkCRt9UbLain8jyqnYMEtXyNuT",
      twitterUrl: "https://x.com/cloonfun",
      chain: "sol",
      name: "CLOON",
      exchange: "GMGN",
      logoUrl: "https://wsrv.nl/?w=32&h=32&url=https%3A%2F%2Fipfs.io%2Fipfs%2Fbafybeicrozkhxjodex5uc4rqn7eyysmi2eh7iw3huw3tsfikra7oinmi7m&dpr=2"
    },
    {
      ticker: "PNP",
      tokenAddress: "ArQNTJtmxuWQ77KB7a1PmoZc5Zd25jXmXPDWBX8qVoux",
      twitterUrl: "https://x.com/predictandpump",
      chain: "sol",
      name: "PNP Exchange",
      exchange: "GMGN",
      logoUrl: "https://pbs.twimg.com/profile_images/1851350952789348352/RWNefUn7_400x400.jpg"
    },
    {
      ticker: "ZEUZ",
      tokenAddress: "GvRf47WPg9uaYcyXEs5UxHL2D39P7yTByBDrQcyMk5wg",
      twitterUrl: "https://x.com/zeuzdottrade",
      chain: "sol",
      name: "Zeuz",
      exchange: "GMGN",
      logoUrl: "https://pbs.twimg.com/profile_images/1879935863804612608/zO2bcCK5_400x400.jpg"
    },
    {
      ticker: "PIPEIQ",
      tokenAddress: "AX8b9A79uDBTKDQoWTzq3NaD1FN4JEDGKR2yTQGhcwjo",
      twitterUrl: "https://x.com/pipeIQai",
      chain: "sol",
      name: "PipeIQ",
      exchange: "GMGN",
      logoUrl: "https://pbs.twimg.com/profile_images/1922778732609032192/qU0sLkmC_400x400.jpg"
    },
    {
      ticker: "GLMPS",
      tokenAddress: "445ksMigJLms4mw29DQkXs8aWBG4S8Z2kTBCtGhd5nGd",
      twitterUrl: "https://x.com/glympsedotfun",
      chain: "sol",
      name: "glympse",
      exchange: "GMGN",
      logoUrl: "https://pbs.twimg.com/profile_images/1919427407980986369/ESyQtdSr_400x400.jpg"
    },
    {
      ticker: "AURA",
      tokenAddress: "CMkj12qHC9RjAUs1MED38Bt7gfyP3TbEpa1mcBno3RUY",
      twitterUrl: "https://x.com/aurascopeapp",
      chain: "sol",
      name: "Aurascope",
      exchange: "GMGN",
      logoUrl: "https://pbs.twimg.com/profile_images/1909690570446192644/VBn0leK__400x400.jpg"
    },
    {
      ticker: "KNET",
      tokenAddress: "CMkj12qHC9RjAUs1MED38Bt7gfyP3TbEpa1mcBno3RUY",
      twitterUrl: "https://x.com/Kingnet_AI",
      chain: "sol",
      name: "Aurascope",
      exchange: "GMGN",
      logoUrl: "https://dd.dexscreener.com/ds-data/tokens/solana/CfVs3waH2Z9TM397qSkaipTDhA9wWgtt8UchZKfwkYiu.png?key=19c232"
    },
    {
      ticker: "UNICORN",
      tokenAddress: "DzN1qkcRdsxQRFb9yVvz73Fnu6SbD3f5oJgArVdx7Nzc",
      twitterUrl: "https://x.com/Unicorn1b",
      chain: "sol",
      name: "Unicorn",
      exchange: "GMGN",
      logoUrl: "https://dd.dexscreener.com/ds-data/tokens/solana/DzN1qkcRdsxQRFb9yVvz73Fnu6SbD3f5oJgArVdx7Nzc.png?key=502db5"
    },
    {
      ticker: "HYLX",
      tokenAddress: "CMkj12qHC9RjAUs1MED38Bt7gfyP3TbEpa1mcBno3RUY",
      twitterUrl: "https://x.com/hyperswapai",
      chain: "sol",
      name: "HyperSwapAI",
      exchange: "GMGN",
      logoUrl: "https://dd.dexscreener.com/ds-data/tokens/solana/7sYAhEucFNkme29jHqSeFYNenAgD8krH9KmJeUs8Un43.png?key=750a78"
    },


  ];


const checkForNewTokens = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/tokens/stats`, {
      headers: {
        'ngrok-skip-browser-warning': 'true'
      }
    });

    if (!response.ok) {

      console.warn(`Background token stats check failed with status: ${response.status}`);
      return;
    }

    const contentType = response.headers.get("Content-Type") || "";
    if (!contentType.includes("application/json")) {
 
        console.warn(`Background token stats check received non-JSON Content-Type: ${contentType}`);
        return;
    }
    
    const data = await response.json();

    if (data.success && data.stats && data.stats.lastUpdated) {
      const serverLastUpdate = new Date(data.stats.lastUpdated).getTime();
      if (serverLastUpdate > lastFetchTime) {
        fetchRecentTokens(); // This will then also use the header if modified as above
        setLastFetchTime(serverLastUpdate);
      }
    }
  } catch (error) {
  
    console.log("Background token check failed in catch block:", error.message);
  }
};
  
  useEffect(() => {
    const interval = setInterval(checkForNewTokens, 10000); // Check every 30 seconds
    
    return () => clearInterval(interval);
  }, [lastFetchTime]);
  

const fetchRecentTokens = async () => {
  setIsLoadingTokens(true);
  setTokenError(null);

  try {
    const url = `${API_BASE_URL}/tokens/recent?count=${chartCount}`;
    const response = await fetch(url, { 
      headers: {
        'ngrok-skip-browser-warning': 'true' 
      }
    });

    if (!response.ok) {
      // Try to get more info if it's an error
      let errorDetails = `Request failed with status ${response.status}`;
      try {
        const errorText = await response.text();
        errorDetails += ` - ${errorText.substring(0, 200)}`; // Get first 200 chars of error
      } catch (e) { /* ignore, just use status */ }
      throw new Error(errorDetails);
    }

    // Verify response content type is JSON
    const contentType = response.headers.get("Content-Type") || "";
    if (!contentType.includes("application/json")) {
      const fallback = await response.text();
      const snippet = fallback.slice(0, 300);
      throw new Error(`Expected JSON but received Content-Type '${contentType}':\n\n${snippet}`);
    }

    // Safely parse JSON
    const data = await response.json();

    // Validate schema
    if (!data.success || !Array.isArray(data.tokens)) {
      throw new Error(`Unexpected JSON schema: ${JSON.stringify(data).slice(0, 300)}`);
    }

    setRecentTokens(data.tokens);
    setLastFetchTime(Date.now());

  } catch (error) {
    console.error("Error fetching recent tokens:", error);
    setTokenError(error.message);
    setActiveTab("popular");  // fallback to hardcoded list
  } finally {
    setIsLoadingTokens(false);
  }
};
  
  
  // Function to refresh token positions
// In TradingInterface.js

  const refreshTokenPositions = async () => {
    setIsLoadingTokens(true);
    // setTokenError(null); // You might want to clear previous errors here too

    try {
      const response = await fetch(`${API_BASE_URL}/tokens/refresh?count=${chartCount}`, { // <--- Add headers
        headers: {
          'ngrok-skip-browser-warning': 'true'
        }
      });

      if (!response.ok) {
        // Similar error handling as above if you want more details
        let errorDetails = `Failed to refresh token positions with status ${response.status}`;
        try {
          const errorText = await response.text();
          errorDetails += ` - ${errorText.substring(0, 200)}`;
        } catch (e) { /* ignore */ }
        throw new Error(errorDetails);
      }
      
      // It's good practice to check Content-Type here too before .json()
      const contentType = response.headers.get("Content-Type") || "";
      if (!contentType.includes("application/json")) {
          const fallback = await response.text();
          const snippet = fallback.slice(0, 300);
          throw new Error(`Expected JSON from refresh but received Content-Type '${contentType}':\n\n${snippet}`);
      }

      const data = await response.json();

      if (data.success && data.tokens) {
        setRecentTokens(data.tokens);
      } else {
        throw new Error(data.error || 'Unknown error refreshing tokens');
      }
    } catch (error) {
      console.error('Error refreshing token positions:', error);
      setTokenError(error.message);
    } finally {
      setIsLoadingTokens(false);
    }
  };
  
  // Fetch tokens when tab or chart count changes
  useEffect(() => {
    if (activeTab === 'newPairs') {
      fetchRecentTokens();
    }
  }, [activeTab, chartCount]);
  
  // Function to handle tab change
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setActiveChart(null);
    setChartSearchQuery('');
    
    // Fetch recent tokens if switching to newPairs tab
    if (tab === 'newPairs') {
      fetchRecentTokens();
    }
  };

  // Function to handle ticker click to initiate chart replacement
  const handleTickerClick = (index) => {
    if (activeTab === 'popular') {
      if (activeChart === index) {
        // If clicking on already active chart, close the dropdown
        setActiveChart(null);
        setChartSearchQuery('');
      } else {
        // Activate chart for replacement
        setActiveChart(index);
        setChartSearchQuery('');
        // Focus the input after a brief delay to allow render
        setTimeout(() => {
          if (chartSearchRef.current) {
            chartSearchRef.current.focus();
          }
        }, 100);
      }
    }
  };
  
  // Function to get search results for chart replacement
// Function to get search results for chart replacement
// Function to get search results for chart replacement
    // Function to get search results for chart replacement
    const getChartSearchResults = () => {
        if (!chartSearchQuery) {
        // Show all popular tokens if no query
        return popularTokens.slice(0, 100);
        }
        
        const lowerQuery = chartSearchQuery.toLowerCase();
        return popularTokens
        .filter(token => 
            token.ticker.toLowerCase().includes(lowerQuery) || 
            token.name.toLowerCase().includes(lowerQuery)
        )
        .slice(0, 100); // Limit to 5 results for dropdown
    };
  
  // Function to replace a chart
  const replaceChart = (index, newChart) => {
    setReplacedCharts({
      ...replacedCharts,
      [index]: newChart
    });
    setActiveChart(null);
    setChartSearchQuery('');
  };
  
  // Handle outside clicks for chart dropdown
  useEffect(() => {
    function handleClickOutside(event) {
      if (chartDropdownRef.current && !chartDropdownRef.current.contains(event.target)) {
        setActiveChart(null);
        setChartSearchQuery('');
      }
    }
    
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [chartDropdownRef]);

  // Get chart to display at a specific index
    // Get chart to display at a specific index
    // Get chart to display at a specific index
    const getChartForIndex = (index) => {
        // If we're in newPairs tab, use the recent tokens
        if (activeTab === 'newPairs') {
        return recentTokens[index] || null;
        }
        
        // If in popular tab and this chart slot has been replaced, use the replacement
        if (activeTab === 'popular' && replacedCharts[index]) {
        return replacedCharts[index];
        }
        
        // For Popular tab, return null initially to show search placeholders
        return null;
    };
    
  const truncateAddress = (address) => {
    if (!address) return '';
    if (address.length <= 10) return address;
    return `${address.substring(0, 6)}...${address.substring(address.length - 4)}`;
  };
  
  // Function to copy address to clipboard
  const copyToClipboard = (address, index) => {
    navigator.clipboard.writeText(address).then(() => {
      setCopiedAddresses({...copiedAddresses, [index]: true});
      setTimeout(() => {
        setCopiedAddresses({...copiedAddresses, [index]: false});
      }, 2000);
    });
  };

  // Generate chart components with GMGN embed
// Generate chart components with GMGN embed
// Generate chart components with GMGN embed
    const renderChart = (chart, index) => {
        // If no chart data available, render placeholder for Popular tab or loading for New Pairs
        if (!chart) {
            if (activeTab === 'popular') {
                return (
                    <div className="h-full border border-gray-700 bg-black flex flex-col items-center justify-center text-gray-400 p-4">
                        <div className="text-center mb-4">
                            <span className="text-lg mb-2 block">Search for a Believe launch</span>
                            <span className="text-sm text-gray-500 block">Type or click to search</span>
                        </div>
                        
                        <div className="bg-gray-900 rounded-md w-full max-w-xs p-2">
                            <div className="flex items-center bg-gray-800 rounded overflow-hidden">
                                <input
                                    ref={index === 0 ? chartSearchRef : null}
                                    type="text"
                                    placeholder="Search by ticker..."
                                    className="bg-transparent border-none outline-none px-3 py-2 text-sm text-gray-300 w-full placeholder-gray-500"
                                    value={chartSearchQuery}
                                    onChange={(e) => setChartSearchQuery(e.target.value)}
                                    onFocus={() => setActiveChart(index)}
                                />
                                {chartSearchQuery && (
                                    <button
                                        className="px-2 text-gray-400 hover:text-white"
                                        onClick={() => setChartSearchQuery('')}
                                    >
                                        ×
                                    </button>
                                )}
                            </div>
                            
                            {/* Show search results if this chart is active */}
                            {activeChart === index && (
                                <div className="mt-2 max-h-40 overflow-y-auto bg-gray-900 rounded shadow-lg p-2">
                                    {getChartSearchResults().length > 0 ? (
                                        getChartSearchResults().map((token, idx) => (
                                            <div 
                                                key={idx}
                                                className="px-3 py-2 hover:bg-gray-800 cursor-pointer flex items-center"
                                                onClick={() => replaceChart(index, {
                                                    name: token.name,
                                                    ticker: token.ticker,
                                                    chain: token.chain || 'sol',
                                                    tokenAddress: token.tokenAddress,
                                                    symbol: `${token.ticker}/USD`,
                                                    exchange: token.exchange || 'GMGN',
                                                    twitterUrl: token.twitterUrl,
                                                    logoUrl: token.logoUrl
                                                })}
                                            >
                                                {/* Fixed logo display in placeholder search results */}
                                                {token.logoUrl ? (
                                                    <img 
                                                        src={token.logoUrl} 
                                                        alt={`${token.ticker} logo`}
                                                        className="w-4 h-4 rounded-full mr-2 object-cover"
                                                        onError={(e) => {
                                                            e.target.onerror = null;
                                                            e.target.style.backgroundColor = '#4b5563';
                                                        }}
                                                    />
                                                ) : (
                                                    <div className="w-4 h-4 rounded-full bg-gray-600 mr-2"></div>
                                                )}
                                                <span className="text-gray-300 font-medium">${token.ticker}</span>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="px-3 py-2 text-gray-400">No matches found</div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                );
            } else {
                return (
                    <div className="h-full border border-gray-700 bg-black flex items-center justify-center text-gray-500">
                        {isLoadingTokens ? 'Loading token data...' : 'No data available'}
                    </div>
                );
            }
        }
        
        const { name, ticker, chain, tokenAddress, logoUrl } = chart;
        
        // Use different timeframes based on active tab
        const interval = activeTab === 'newPairs' ? '1s' : '5';
        const gmgnUrl = `https://www.gmgn.cc/kline/${chain}/${tokenAddress}?theme=dark&interval=${interval}`;
        
        // Determine styling based on chartCount - smaller for 10 charts
        const isCompact = chartCount === 10;
        
        return (
            <div className="h-full border border-gray-700 bg-black relative flex flex-col">
                <div className={`${isCompact ? 'py-1.5 px-2 text-xs' : 'py-3 px-4 text-sm'} border-b border-gray-700 flex justify-between items-center`}>
                    <div className="flex items-center gap-2">
                        {/* Logo - use actual logo if available, otherwise placeholder */}
                        {logoUrl ? (
                            <img 
                                src={logoUrl} 
                                alt={`${ticker} logo`}
                                className={`${isCompact ? 'w-5 h-5' : 'w-7 h-7'} rounded-full object-cover`}
                                onError={(e) => {
                                    // If image fails to load, replace with default placeholder
                                    e.target.onerror = null;
                                    e.target.style.backgroundColor = '#4b5563'; // Gray background as fallback
                                }}
                            />
                        ) : (
                            <div className={`${isCompact ? 'w-5 h-5' : 'w-7 h-7'} rounded-full bg-gray-600`}></div>
                        )}
                        
                        {/* Ticker with $ prefix - clickable in Popular tab */}
                        <div className="relative">
                            <span 
                                className={`font-bold text-gray-200 ${isCompact ? 'text-sm' : 'text-base'} ${activeTab === 'popular' ? 'cursor-pointer hover:text-green-300' : ''}`}
                                onClick={() => activeTab === 'popular' && handleTickerClick(index)}
                            >
                                ${ticker}
                            </span>
                            
                            {/* Dropdown for chart replacement (only in Popular tab) */}
                            {activeTab === 'popular' && activeChart === index && (
                                <div 
                                    className="absolute top-full left-0 mt-1 z-20 bg-gray-900 rounded shadow-lg p-2 w-64"
                                    ref={chartDropdownRef}
                                >
                                    <div className="flex items-center mb-2 bg-gray-800 rounded overflow-hidden">
                                        <input
                                            ref={chartSearchRef}
                                            type="text"
                                            placeholder="Search for ticker..."
                                            className="bg-transparent border-none outline-none px-3 py-2 text-sm text-gray-300 w-full"
                                            value={chartSearchQuery}
                                            onChange={(e) => setChartSearchQuery(e.target.value)}
                                        />
                                        {chartSearchQuery && (
                                            <button
                                                className="px-2 text-gray-400 hover:text-white"
                                                onClick={() => setChartSearchQuery('')}
                                            >
                                                ×
                                            </button>
                                        )}
                                    </div>
                                    
                                    <div className="max-h-40 overflow-y-auto">
                                        {getChartSearchResults().length > 0 ? (
                                            getChartSearchResults().map((token, idx) => (
                                                <div 
                                                    key={idx}
                                                    className="px-3 py-2 hover:bg-gray-800 cursor-pointer flex items-center"
                                                    onClick={() => replaceChart(index, {
                                                        name: token.name,
                                                        ticker: token.ticker,
                                                        chain: token.chain || 'sol',
                                                        tokenAddress: token.tokenAddress,
                                                        symbol: `${token.ticker}/USD`,
                                                        exchange: token.exchange || 'GMGN',
                                                        twitterUrl: token.twitterUrl,
                                                        logoUrl: token.logoUrl
                                                    })}
                                                >
                                                    {/* Fixed logo display in chart dropdown */}
                                                    {token.logoUrl ? (
                                                        <img 
                                                            src={token.logoUrl} 
                                                            alt={`${token.ticker} logo`}
                                                            className="w-4 h-4 rounded-full mr-2 object-cover"
                                                            onError={(e) => {
                                                                e.target.onerror = null;
                                                                e.target.style.backgroundColor = '#4b5563';
                                                            }}
                                                        />
                                                    ) : (
                                                        <div className="w-4 h-4 rounded-full bg-gray-600 mr-2"></div>
                                                    )}
                                                    <span className="text-gray-300 font-medium">${token.ticker}</span>
                                                </div>
                                            ))
                                        ) : (
                                            <div className="px-3 py-2 text-gray-400">No matches found</div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                        
                        {/* Trade button */}
                        <a 
                            href={`https://gmgn.ai/sol/token/${tokenAddress}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`ml-1 px-2 py-0.5 bg-green-800 text-green-300 rounded font-medium hover:bg-green-700 ${isCompact ? 'text-sm' : 'text-base'}`}
                        >
                            Trade
                        </a>
                    </div>
                    
                    <div className="flex items-center gap-3">
                        {/* X (Twitter) button - Only show if twitter URL is available */}
                        {chart.twitterUrl && (
                            <a 
                                href={chart.twitterUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={`${isCompact ? 'p-1' : 'p-1.5'} rounded hover:bg-gray-800 text-gray-400 hover:text-white`}
                            >
                                <XIcon />
                            </a>
                        )}
                        
                        <div className="flex items-center">
                            {/* CA label right outside the blue background - hide in compact mode */}
                            {!isCompact && <span className="text-white text-base mr-1">CA:</span>}
                            
                            {/* Contract address with copy button - in compact mode, just show copy button */}
                            <div className={`flex items-center gap-1 bg-gray-900 rounded ${isCompact ? 'px-2 py-1' : 'px-3 py-1.5'}`}>
                                {/* Only show address in non-compact mode */}
                                {!isCompact && <span className="text-gray-400 text-xs">{truncateAddress(tokenAddress)}</span>}
                                
                                <button 
                                    className="p-0.5 rounded hover:bg-gray-800 text-gray-400 hover:text-white"
                                    onClick={() => copyToClipboard(tokenAddress, index)}
                                    title={isCompact ? tokenAddress : ""}
                                >
                                    {copiedAddresses[index] ? <Check size={isCompact ? 12 : 14} className="text-green-500" /> : <Copy size={isCompact ? 12 : 14} />}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="flex-grow relative">
                    <iframe 
                        src={gmgnUrl}
                        className="w-full h-full border-0"
                        title={`${name} Chart`}
                        loading="lazy"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                </div>
            </div>
        );
    };

  return (
    <div className="bg-black text-white min-h-screen flex flex-col h-screen overflow-hidden">
      {/* Header */}
      <header className="flex justify-between items-center p-4 border-b border-gray-800">
        <div className="flex items-center">
          <div className="text-green-500 font-mono text-lg font-bold">BelieveCharts</div>
        </div>
        
        {/* Navigation Tabs - Equal width */}
        <div className="flex">
          <div className="flex bg-gray-900 rounded overflow-hidden" style={{ width: '220px' }}> {/* Fixed width for both buttons */}
            <button 
              className={`w-1/2 py-1.5 text-sm font-medium ${activeTab === 'newPairs' ? 'bg-green-800 text-green-300' : 'text-gray-400 hover:bg-gray-800 hover:text-white'}`}
              onClick={() => handleTabChange('newPairs')}
            >
              New Pairs
            </button>
            <button 
              className={`w-1/2 py-1.5 text-sm font-medium ${activeTab === 'popular' ? 'bg-green-800 text-green-300' : 'text-gray-400 hover:bg-gray-800 hover:text-white'}`}
              onClick={() => handleTabChange('popular')}
            >
              Popular
            </button>
          </div>
        </div>
        
        <div className="flex items-center gap-6">
          
          {/* Chart Count Selector */}
          <div className="flex bg-gray-900 rounded overflow-hidden">
            {[1, 2, 4, 6, 10].map(count => (
              <button 
                key={count}
                className={`px-3 py-1 text-sm ${chartCount === count ? 'bg-green-800 text-green-300' : 'text-gray-400 hover:bg-gray-800 hover:text-white'}`}
                onClick={() => setChartCount(count)}
              >
                {count}
              </button>
            ))}
          </div>
        </div>
      </header>
      
      {/* Error message if token fetching fails */}
      {tokenError && activeTab === 'newPairs' && (
        <div className="bg-red-900 text-red-200 px-4 py-2 text-sm">
          Error loading new pairs: {tokenError}. <button className="underline" onClick={fetchRecentTokens}>Try again</button>
        </div>
      )}
      
      {/* Chart grid */}
      <div className={`grid gap-0.5 flex-1 w-full h-full ${
        chartCount === 1 ? 'grid-cols-1 grid-rows-1' : 
        chartCount === 2 ? 'grid-cols-2 grid-rows-1' : 
        chartCount === 4 ? 'grid-cols-2 grid-rows-2' : 
        chartCount === 6 ? 'grid-cols-3 grid-rows-2' : 
        'grid-cols-5 grid-rows-2'
      }`} style={{ minHeight: '0', gridAutoRows: '1fr', gridAutoColumns: '1fr' }}>
        {/* Render charts based on selected count */}
        {Array.from({ length: chartCount }).map((_, index) => {
          // Get the chart to display (either original, replacement, or from recent tokens)
          const chartToDisplay = getChartForIndex(index);
          
          return (
            <div key={index} className="h-full">
              {renderChart(chartToDisplay, index)}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TradingInterface;